module.exports = __webpack_public_path__ + "img/1.eb2be8d0.jpg";